import { authService } from '../../services/auth/authService';

/**
 * OnAuthStateChangedUseCase
 * 
 * Subscribe to Firebase authentication state changes.
 * Returns unsubscribe function.
 * 
 * Note: This only returns the Firebase user ID, not the full user object.
 * Full user data is stored in SecureStorage and loaded when needed.
 */
export class OnAuthStateChangedUseCase {
    execute(callback: (firebaseUserId: string | null) => void): () => void {
        return authService.onAuthStateChanged(callback);
    }
}

export const onAuthStateChangedUseCase = new OnAuthStateChangedUseCase();
